import { type PropsWithChildren, type Ref } from 'react'
import { Stack } from '../../primitives/Stack'
import { useSpacingToken } from '../../theme/hooks/use-spacing-token'

type Props = PropsWithChildren & {
  /**
   * Remove the side padding on Content
   * @default false
   */
  noPaddingSides?: boolean

  /**
   * Ref forwarded to the scroll container. Useful for resetting `scrollTop`
   * when navigating between views inside the same Modal.
   */
  ref?: Ref<HTMLDivElement>
}

export const ModalContent = ({ children, noPaddingSides = false, ref }: Props) => {
  const spacingToken = useSpacingToken()

  return (
    <Stack
      ref={ref}
      className="DhlModal-content"
      sx={{
        position: 'relative',
        display: 'flex',
        flex: 1,
        overflow: 'auto',
        py: 2,
        px: noPaddingSides ? 0 : spacingToken,
      }}
    >
      {children}
    </Stack>
  )
}
